// extracted by mini-css-extract-plugin
export default {"genericCard":"to-z","inline":"uo-z","mastercard":"vo-z","discover":"wo-z","visa":"xo-z","amex":"yo-z","active":"zo-z"};